import React from 'react';
import { Link } from 'react-router-dom';

const FOOTER_NAV = {
  Spending: [
    { label: 'Latest quarter', href: '/latest-quarter' },
    { label: 'All-time', href: '/all-time' },
    { label: 'Contracts', href: '/contracts' },
    { label: 'Donations', href: '/donations' },
    { label: 'Projects', href: '/projects' },
  ],
  Accountability: [
    { label: 'Health transfer', href: '/health-transfer' },
    { label: 'Immigration', href: '/immigration' },
    { label: 'Disability programs', href: '/disability' },
    { label: 'Housing', href: '/housing' },
    { label: 'Public sector', href: '/public-sector' },
  ],
  Analysis: [
    { label: 'Where $100 goes', href: '/federal-spending-100' },
    { label: 'Inflation', href: '/inflation' },
    { label: 'The Squeeze', href: '/the-squeeze' },
  ],
  Explore: [
    { label: 'Outliers', href: '/outliers' },
    { label: 'Categories', href: '/categories' },
    { label: 'Compare', href: '/compare' },
    { label: 'News', href: '/news' },
  ],
  About: [
    { label: 'Methodology', href: '/methodology' },
  ],
};

export default function Footer({ meta }) {
  return (
    <footer className="bg-ink-800 text-cream-100 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-20 pb-12">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10">
          <div className="col-span-2 md:col-span-5">
            <div className="flex items-baseline gap-2">
              <span className="font-serif italic font-light text-3xl text-cream-100">Spill the Hill</span>
              <span className="kicker text-copper-500">Canada</span>
            </div>
            <p className="mt-5 text-[14px] leading-[1.75] text-cream-100/65 max-w-sm">
              An accountability ledger for Canadian government spending, drawn from public data released by
              the House of Commons, Elections Canada, Statistics Canada, and open.canada.ca. We don't
              recalculate, re-categorise, or estimate; every figure traces back to a public source.
            </p>
            <div className="mt-6 flex items-center gap-2 text-[12px] text-cream-100/50">
              <span className="h-1.5 w-1.5 rounded-full bg-sage-500 inline-block" />
              <span>Live data · refreshed every 6 hours</span>
            </div>
          </div>
          <div className="col-span-2 md:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
            {Object.entries(FOOTER_NAV).map(([heading, links]) => (
              <div key={heading}>
                <h4 className="kicker text-copper-500 mb-4">{heading}</h4>
                <ul className="space-y-2.5">
                  {links.map((l) => (
                    <li key={l.label}>
                      <Link to={l.href} className="text-[14px] text-cream-100/75 hover:text-copper-500 transition">
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream-100/10 flex flex-col md:flex-row justify-between text-[11px] tracking-wider uppercase text-cream-100/40 gap-2">
          <div>
            {meta?.updated ? `Last refreshed ${new Date(meta.updated).toLocaleString('en-CA', { dateStyle: 'medium', timeStyle: 'short' })}` : 'Live data feed'}
            <span className="mx-2 text-copper-500">·</span>
            Latest data {meta?.latest_quarter || '—'}
          </div>
          <div>Open Government Licence — Canada</div>
        </div>
      </div>
    </footer>
  );
}
